import { ChangeDetectionStrategy, Component, Input, ChangeDetectorRef, AfterViewChecked } from '@angular/core'
import { EditComponent } from '../edit-component'

@Component({
  selector: 'app-string-input',
  templateUrl: './string-input.component.html',
  styleUrls: ['./string-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StringInputComponent extends EditComponent implements AfterViewChecked {
  changed = false
  private previousValue: any = null

  // Issue: The blur event is being triggered before the click event can be processed. When you click a button after focusing
  // on an input field, the blur event of the input is fired first. The blur event can cause especially in the Wizard a re-render of the DOM.
  // This can potentially interrupt the processing of the button click. So the wizard popup will not be closed and button clicks will not be procssed.

  valueCache: string | null = null

  constructor(private cdr: ChangeDetectorRef) {
    super()
  }

  ngAfterViewChecked() {
    // PrimeNG checks filled in ngDoCheck() because ChangeDetectionStrategy.OnPush
    if (this.control && this.control.value !== this.previousValue) {
      this.previousValue = this.control.value
      this.cdr.markForCheck()
    }
  }

  handleBlur(event: FocusEvent) {
    if (this.control?.value !== this.valueCache) {
      this.onUpdate.emit()
    }
  }

  handleOnFocus() {
    this.valueCache = this.control?.value
    this.onFocus.emit()
  }
}
